import * as angular from 'angular';
import { SupportsRosterComponent } from './supports-roster.component';

export const SupportsRosterModule = angular
  .module('supportsRoster', [])
  .component('supportsRoster', SupportsRosterComponent).name;
